/* eslint-disable react/prop-types */
import React, { createContext, useContext, useEffect, useState } from "react";
import { login, logout } from "actions/auth";
import { ROLES } from "components/common/constant";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // const [auth, setAuth] = useState({
  //   name: null,
  //   token: null,
  //   role: null,
  // });

  const [auth, setAuth] = useState({
    name: null,
    email: null,
    employeeID: null,
    role: null,
    department: null,
    isPasswordSet: "NO",
  });

  const [loading, setLoading] = useState(true);

  // Restore session
  useEffect(() => {
    const stored = localStorage.getItem("pt");
    if (stored) {
      setAuth(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const loginWithPassword = async (loginData) => {
    const res = await login(loginData);

    if (res.code === 200) {
      if (!Object.values(ROLES).includes(res.data?.role)) {
        return { success: false, message: "Access denied" };
      }

      setAuth(res.data);
      localStorage.setItem("pt", JSON.stringify(res.data));

      return { success: true, data: res.data };
    }

    return { success: false, message: res?.message };
  };

  const logoutUser = async () => {
    try {
      await logout();
    } finally {
      localStorage.removeItem("pt");
      // setAuth({ name: null, token: null, role: null });
      setAuth({  name: null,  email: null,  employeeID: null,  role: null,  department: null,  isPasswordSet: "NO",});

    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...auth,
        // isAuthenticated: !!auth?.token,
        isAuthenticated: !!auth?.role,
        loading,
        loginWithPassword,
        logoutUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
